import { render, staticRenderFns } from "./DropdownFormItem.vue?vue&type=template&id=0b52bc3a&scoped=true&"
import script from "./DropdownFormItem.vue?vue&type=script&lang=js&"
export * from "./DropdownFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../.jenkins/workspace/DMSDashboardDeployLIVE/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b52bc3a",
  null
  
)

export default component.exports